import { useEffect } from 'react'
import { POLL_INTERVAL_MS } from '@/data/api'

/**
 * Poll member account balances while the page is open.
 * Aggregate has no hierarchy credit-stream SSE — always poll.
 */
export function useMemberAccountPoll(
  refetch: () => unknown,
  intervalMs: number = POLL_INTERVAL_MS,
): void {
  useEffect(() => {
    const timer = window.setInterval(() => {
      void refetch()
    }, intervalMs)
    return () => window.clearInterval(timer)
  }, [refetch, intervalMs])
}
